export const dias = [
  { nombre: "Lunes" },
  { nombre: "Martes" },
  { nombre: "Miércoles" },
  { nombre: "Jueves" },
  { nombre: "Viernes" },
  { nombre: "Sábado" },
  { nombre: "Domingo" },
];

export const horario = [
  { nombre: "Mañana" },
  { nombre: "Media Tarde" },
  { nombre: "Tarde" },
  { nombre: "Noche" },
  { nombre: "Madrugada" },
];

export const obtenerRangoHorario = (rangos) => {
  const resultados = [];

  rangos.forEach((rango) => {
    let horaMin = "";
    let horaMax = "";

    switch (rango) {
      case "Mañana":
        horaMin = "07";
        horaMax = "12";
        break;
      case "Media Tarde":
        horaMin = "12";
        horaMax = "16";
        break;
      case "Tarde":
        horaMin = "16";
        horaMax = "19";
        break;
      case "Noche":
        horaMin = "19";
        horaMax = "24";
        break;
      case "Madrugada":
        horaMin = "00";
        horaMax = "07";
        break;
      default:
        break;
    }

    resultados.push({ horaMin, horaMax });
  });

  return resultados;
};

//KIN

export const rangoHorarioKinesio = [
  { nombre: "7:30 A 10hs" },
  { nombre: "10 A 12hs" },
  { nombre: "12 A 14hs" },
  { nombre: "14 A 16hs" },
  { nombre: "16 A 18hs" },
  { nombre: "18 A 20hs" },
];

export const rangoHorarioDefaultKinesio = [
  "730|1000",
  "1000|1200",
  "1200|1400",
  "1400|1600",
  "1600|1800",
  "1800|2000",
];

export const horarioCompletoKin = [
  {
    descripcion: "7:30 A 10hs",
    rango: "730|1000",
  },
  {
    descripcion: "10 A 12hs",
    rango: "1000|1200",
  },
  {
    descripcion: "12 A 14hs",
    rango: "1200|1400",
  },
  {
    descripcion: "14 A 16hs",
    rango: "1400|1600",
  },
  {
    descripcion: "16 A 18hs",
    rango: "1600|1800",
  },
  {
    descripcion: "18 A 20hs",
    rango: "1800|2000",
  },
];

export const diasString = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

export const diasKin = [
  { nombre: "Lunes" },
  { nombre: "Martes" },
  { nombre: "Miércoles" },
  { nombre: "Jueves" },
  { nombre: "Viernes" },
  { nombre: "Sábado" },
];

export const diaSemanalDefaultKinesio = [1, 2, 3, 4, 5, 6];
